/**
 * Recorder Store (Zustand)
 * Manages recording UI state and recorder settings
 */

import { create } from "zustand";

export interface RecorderStore {
  isRecording: boolean;
  inputDeviceId: string | null;
  monitoringEnabled: boolean;
  countInBars: 0 | 1 | 2;
  echoCancellation: boolean;
  noiseSuppression: boolean;
  autoGainControl: boolean;
  levelMeter: { rms: number; peak: number };

  setRecording: (recording: boolean) => void;
  setInputDevice: (deviceId: string | null) => void;
  setMonitoring: (enabled: boolean) => void;
  setCountIn: (bars: 0 | 1 | 2) => void;
  setEchoCancellation: (enabled: boolean) => void;
  setNoiseSuppression: (enabled: boolean) => void;
  setAutoGainControl: (enabled: boolean) => void;
  setLevelMeter: (rms: number, peak: number) => void;
}

export const useRecorderStore = create<RecorderStore>((set) => ({
  isRecording: false,
  inputDeviceId: null,
  monitoringEnabled: false,
  countInBars: 0,
  echoCancellation: false,
  noiseSuppression: false,
  autoGainControl: false,
  levelMeter: { rms: 0, peak: 0 },

  setRecording: (recording) => set({ isRecording: recording }),
  setInputDevice: (deviceId) => set({ inputDeviceId: deviceId }),
  setMonitoring: (enabled) => set({ monitoringEnabled: enabled }),
  setCountIn: (bars) => set({ countInBars: bars }),
  setEchoCancellation: (enabled) => set({ echoCancellation: enabled }),
  setNoiseSuppression: (enabled) => set({ noiseSuppression: enabled }),
  setAutoGainControl: (enabled) => set({ autoGainControl: enabled }),
  setLevelMeter: (rms, peak) => set({ levelMeter: { rms, peak } }),
}));
